import React from 'react';
import { IconBarrierBlock } from '@tabler/icons-react';

const ContractorView = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '75vh', padding: '2rem' }}>
            <div className="text-center p-5 bg-white rounded-4 shadow-sm border" style={{ maxWidth: '500px', borderColor: '#e5e7eb' }}>
                <div className="mb-4 text-warning" style={{ opacity: 0.9 }}>
                    <IconBarrierBlock size={80} stroke={1.5} />
                </div>
                <h2 className="fw-bold mb-3" style={{ color: '#111827', letterSpacing: '-0.5px' }}>Under Construction</h2>
                <p className="text-secondary mb-0" style={{ fontSize: '1.05rem', lineHeight: '1.6' }}>
                    The Contractor View dashboard is currently being built and tested. Please check back soon for exciting updates to this module!
                </p>
            </div>
        </div>
    );
};

export default ContractorView;
